import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "../contexts/I18nContext";

export default function ProductCard({ product, index = 0 }) {
  const { t, lang } = useI18n();
  const name = product.name[lang] || product.name.fr;
  const desc = product.description[lang] || product.description.fr;

  return (
    <Link
      to={`/produits/${product.category}/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group relative block bg-[#0b0b0b] border border-white/5 hover:border-[#39FF14]/60 transition-all duration-300 overflow-hidden animate-slide-up"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      {/* Image */}
      <div className="aspect-[4/3] bg-black overflow-hidden relative">
        <img
          src={product.image}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent opacity-70" />
        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
             style={{ background: "radial-gradient(ellipse at center, rgba(57,255,20,0.18), transparent 70%)" }} />
      </div>

      {/* Content */}
      <div className="p-6 relative">
        <div className="label-tech mb-3">{product.subcategory.replace(/-/g, " ")}</div>
        <h3 className="font-display text-xl sm:text-2xl font-semibold text-white leading-tight group-hover:text-[#39FF14] transition-colors">
          {name}
        </h3>
        <p className="mt-3 text-sm text-zinc-400 font-body line-clamp-2">{desc}</p>

        <div className="mt-5 flex items-center justify-between">
          <span className="font-mono text-xs uppercase tracking-widest text-[#39FF14]">
            {t.products.from}
          </span>
          <span className="inline-flex items-center gap-1 font-display font-bold uppercase text-xs tracking-widest text-white group-hover:text-[#39FF14] transition-colors">
            {t.products.view}
            <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </span>
        </div>
      </div>

      {/* Bottom neon line on hover */}
      <div className="absolute bottom-0 left-0 h-[2px] w-0 bg-[#39FF14] group-hover:w-full transition-all duration-500 neon-glow-sm" />
    </Link>
  );
}
